import React from 'react';
import PageHead from '../components/PageHead';
import { summary, skills } from '../data/portfolio';

const About = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 pb-8">
      <PageHead eyebrow={summary.eyebrow} title={summary.title} />

      <div className="space-y-5 text-[16px] leading-[1.8] text-ink-soft mt-4">
        {summary.paragraphs.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>

      <div className="grid gap-5 sm:grid-cols-2 mt-12">
        {summary.meta.map((m) => (
          <div key={m.k} className="group rounded-xl border border-border p-5 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all">
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute mb-2">{m.k}</div>
            <div className="text-[14.5px] text-foreground/95">{m.v}</div>
          </div>
        ))}
      </div>

      <div className="mt-20">
        <div className="dot-eyebrow mono uppercase tracking-[0.2em] text-[11px] text-ink-mute mb-4">
          Technical Expertise
        </div>
        <h2 className="text-2xl md:text-3xl tracking-tight font-medium mb-10">
          Technical Skills & Toolsets
        </h2>

        <div className="grid gap-5 md:grid-cols-2">
          {skills.map((s) => (
            <div
              key={s.heading}
              className="group rounded-xl border border-border p-5 bg-card/40 hover:border-brand/60 hover:bg-card/70 hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              <h3 className="text-[15px] font-semibold text-foreground mb-3">{s.heading}</h3>
              <div className="flex flex-wrap gap-1.5 mb-4">
                {s.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[11.5px] mono px-2 py-1 rounded-md border border-border text-ink-soft group-hover:border-brand/40"
                  >
                    {t}
                  </span>
                ))}
              </div>
              <p className="text-[13.5px] leading-relaxed text-ink-mute">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
